<template>
  <label class="form-label" :class="[align, { required }]">
    <slot></slot>
  </label>
</template>

<script>
/*
 * 使用自定义form-label时，把el-form上hide-required-asterisk属性设置为true,
 * */
export default {
  name: 'form-label',
  props: {
    align: {
      type: String,
      default: 'justify'
    },
    required: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.form-label {
  display: block;
  width: 100%;

  &.left {
    text-align: left;
  }

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }

  &.justify {
    text-align-last: justify;
  }

  &.required {
    position: relative;
    &::after {
      position: absolute;
      top: 0;
      left: -8px;
      color: #f55656;
      content: '*';
    }
  }
}
</style>
